import {
  WAITING_ROOM_REQUEST_TYPE,
  WaitingRoomRequestType,
} from 'models/WaitingRoom';
import { ObjectValues } from 'types';

// Approving through the link the request arrived on is the default; the other
// option hands off to the create-secure-link drawer instead of resolving here.
export const GRANT_ACCESS_VIA = {
  EXISTING_LINK: 'existing_link',
  NEW_LINK: 'new_link',
} as const;

export type GrantAccessVia = ObjectValues<typeof GRANT_ACCESS_VIA>;

export const GRANT_ACCESS_VIA_FIELD = 'grantAccessVia';

// Every secure link request opens under the same title; what the requester is
// actually after is said by the target label and the submit button.
export const SECURE_LINK_REVIEW_TITLE = 'secureLinkAccessRequest';

type SecureLinkReviewVariant = {
  // Says which of the three things the requester is after.
  targetLabel: string;
  submitLabel: string;
  footnote: string;
  // Only the two outcomes that let someone into the room ask for roles. Sending
  // a password to a recipient of the link grants nothing new, so asking the
  // seller to pick roles first would be noise.
  hasRoles: boolean;
};

export const SECURE_LINK_REVIEW_VARIANTS: Partial<
  Record<WaitingRoomRequestType, SecureLinkReviewVariant>
> = {
  [WAITING_ROOM_REQUEST_TYPE.SECURE_LINK_ACCESS]: {
    targetLabel: 'requestingAccessTo',
    submitLabel: 'approve',
    footnote: 'secureLinkApproveFootnote',
    hasRoles: true,
  },
  [WAITING_ROOM_REQUEST_TYPE.SECURE_LINK_PASSWORD]: {
    targetLabel: 'requestingPasswordFor',
    submitLabel: 'sendPassword',
    footnote: 'secureLinkSendPasswordFootnote',
    hasRoles: false,
  },
  [WAITING_ROOM_REQUEST_TYPE.SECURE_LINK_EXPIRED]: {
    targetLabel: 'requestingToExtend',
    submitLabel: 'extend',
    footnote: 'secureLinkExtendFootnote',
    hasRoles: true,
  },
};
